import { lazy } from "react";
export { OAUTH_SETTINGS_PATH } from "./oauth-settings-path";
export const OauthSettings = lazy(
  () =>
    import(/* webpackChunkName: "oauth-settings-path" */ "./oauth-settings"),
);
